// pages/ThankYou.js
const ThankYou = () => {
  return (
    <div className="thank-you">
      <h1>Бронирование успешно создано!</h1>
      <p>С вами свяжутся для подтверждения.</p>
    </div>
  );
};

export default ThankYou;